import { v4 as uuidv4 } from 'uuid';

export function LinkSeller(props = {}, childrenComponents = []) {
	return {
		componentName: 'LinkSeller',
		componentId: uuidv4(),
		title: '',
		props: Object.assign(
			{
				message: '',
			},
			props,
		),
		childrenComponents,
	};
}
